import { type MCPServerInfo } from '../../types';

const NotionServer: MCPServerInfo = {
  serverId: 'NOTION',
  name: 'Notion',
  slug: 'notion',
  description: 'Notion MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.notion.com/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default NotionServer;
